// LIBRERIE JS
import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// ICONE
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faHome, faFileLines } from "@fortawesome/free-solid-svg-icons";

const ServicesMain: React.FC = () => {

    const { t } = useTranslation();

    // Services List
    const services = [
        {
            icons:  <FontAwesomeIcon icon={faStar} />,
            subTitle: t("servicesPage.subTitle1"),
            lists: [t("servicesPage.list1Element1"), t("servicesPage.list1Element2")]
        },
        {
            icons: <FontAwesomeIcon icon={faHome} />,
            subTitle: t("servicesPage.subTitle2"),
            lists: [t("servicesPage.list2Element1"), t("servicesPage.list2Element2")]
        },
        {
            icons:<FontAwesomeIcon icon={faFileLines} />,
            subTitle: t("servicesPage.subTitle3"),
            lists: [t("servicesPage.list3Element1"), t("servicesPage.list3Element2")]
        },
    ]

    const boxesServies = useRef<(HTMLLIElement|null)[]>([]);
    const setRef = (element: HTMLLIElement|null, index: number) => {
        boxesServies.current[index] = element;
    }
    const [visible, setVisible] = useState<boolean[]>([false,false,false,false])

    useEffect(() => {
        const handleScroll = () => {
            boxesServies.current.forEach((liElement, index) => {
                const liPosition = liElement?.getBoundingClientRect();
                const positionInDOM = liPosition? liPosition.bottom + window.scrollY : 0
                const clientViewHeight = window.scrollY + window.innerHeight;
                if( positionInDOM < clientViewHeight){
                    setVisible((prevVisible) => {
                        const newVisible = [...prevVisible]; 
                        newVisible[index] = true; 
                        return newVisible;
                    });
                }
            })
        }

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, [])
    
    return(
        <>
            <div className="mb-4">
                <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }}></p>
            </div>
            <ul className="list-unstyled services-box">
                {services.map((service, index) => 
                    <li 
                    className={`mb-4 d-sm-flex align-items-center ${visible[index]? 'visible' : ''}`} 
                    key={index} 
                    ref={(element) => setRef(element, index)}
                    >
                        <i className="d-block text-center">{service.icons}</i>
                        <div>
                            <h4>{service.subTitle}</h4>
                            <ul className="pl-3">
                                {service.lists.map((listElement, index) => 
                                    <li className="mb-2" key={index}>{listElement}</li>
                                )}
                            </ul>
                        </div>
                    </li>
                )}
            </ul>
        </>
    )
};
export default ServicesMain;